import { Component, OnInit, OnDestroy } from '@angular/core'
import { Observable } from 'rxjs'
import { GlobalMessageService, GlobalMessageType } from '@spartacus/core'
import { VSAuthService } from '../../../shared/util/auth.service'

@Component({
  standalone: false,
  selector: 'vs-sso-redirect',
  templateUrl: './sso-redirect.component.html',
  styleUrls: ['./sso-redirect.component.scss'],
})
export class SsoRedirectComponent implements OnInit, OnDestroy {
  authError$: Observable<any>
  authErrorSubscription: any
  unauthorizedUser = false
  disabledUser = false

  constructor(
    private vsAuthSerice: VSAuthService,
    protected globalMessageService: GlobalMessageService
  ) {}

  ngOnInit(): void {
    this.authError$ = this.vsAuthSerice.authErrorError$
    this.authErrorSubscription = this.authError$.subscribe(
      (res: any) => {
        if (res.code == '2000') {
          this.unauthorizedUser = true
        } else if (res.code == '2001') {
          this.disabledUser = true
        }
      },
      (error) => {
        this.globalMessageService.add(
          error,
          GlobalMessageType.MSG_TYPE_ERROR,
          5000
        )
        window.scrollTo(0, 0)
      }
    )
  }

  ngOnDestroy(): void {
    this.authErrorSubscription.unsubscribe()
  }
}
